<template>
  <div>
    <b-card no-body border-variant="msstream" class="marginal">
      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h6 class="m-0">
          <b-row class="align-items-center justify-content-center">
            <font-awesome-icon icon="user-friends" />&nbsp;
            {{$ml.get('teams')}}
            &nbsp;<b-badge variant="light"> {{teams.length}}</b-badge>
          </b-row>
        </h6>
      </b-card-header>
      <b-card-body>

    <div>
      <b-table
        class="small"
        show-empty
        centered
        responsive
        striped
        bordered
        :items="teams"
        :fields="teamsTable"
      >
        <template v-slot:cell(teamname)="row">
          <b-row class="justify-content-between align-items-center mr-2 ml-2  ">

            <div style="word-break:break-word; max-width:250px; margin:10px 0px">{{ row.item.teamName }}</div>
            <b-button
              size="sm"
              variant="darkblue"
              @click="
                teamSelected = row.item;
                openChatTeam();
              "
            >
              <font-awesome-icon :icon="['fas', 'comments']" />
              Chat
            </b-button>

          </b-row>
        </template>

        <template v-slot:cell(descriptionTeam)="row">
          <div style="word-break:break-word; max-width:250px; margin:10px 0px">{{ row.item.teamDescription }}</div>
        </template>

        <template v-slot:cell(owner)="row">
          <div style="word-break:break-word; max-width:250px; margin:10px 0px">{{ row.item.ownerTeam }}</div>
        </template>


        <template v-slot:cell(members)="row">
          <div v-for="(collab, idx) in row.item.collabsTeam" :key="idx"> 
            <b-row class="justify-content-center align-items-center" style="min-width:100px">
            <div class="divName2">{{ collab.username }}</div>&nbsp;
            <small>
            <font-awesome-icon
            v-if="collab.role === 'viewer'"
            :icon="['fas', 'eye']"
            style="color: black"
            title="viewer"
            />
            <font-awesome-icon
            v-if="collab.role === 'editor'"
            :icon="['fas', 'edit']"
            style="color: black"
            title="editor"
            />
            <font-awesome-icon
            v-if="collab.role === 'admin'"
            :icon="['fas', 'cog']"
            style="color: black"
            title="admin"
            />
            <font-awesome-icon
            v-if="collab.role === 'owner'"
            :icon="['fas', 'cog']"
            style="color: #ba0000"
            title="owner"
            />
            </small>
            </b-row>
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <b-row class="justify-content-center m-2">
          <b-button
            variant="mswarning"
            size="sm"
            @click="teamSelected = JSON.parse(JSON.stringify(row.item));"
            v-b-modal.modal-edit-team
            v-if="row.item.ownerTeam === $auth.getMyUser().username"
            ><font-awesome-icon icon="edit" />
            {{$ml.get('modify')}}
          </b-button>
          <b-button
            disabled
            size="sm"
            @click="teamSelected = row.item"
            v-b-modal.modal-edit-team
            v-else
            ><font-awesome-icon icon="edit" />
            {{$ml.get('norights')}}
          </b-button>

          </b-row>
          <b-row class="justify-content-center m-2">
          <b-button
            variant="quanteec"
            size="sm"
            @click="
              teamSelected = row.item;
              showModal('confirmDelete');
            "
            v-if="row.item.ownerTeam === $auth.getMyUser().username"
            >
              <font-awesome-layers>
                <font-awesome-icon icon="user-friends" />
                <font-awesome-icon icon="times" transform="shrink-7 right-15 up-1" />              
              </font-awesome-layers>&nbsp;&nbsp;&nbsp;
            {{$ml.get('delete')}}
          </b-button>
          </b-row>
        </template>
      </b-table>
      <b-row class="justify-content-between" >
        <b-col style="padding: 0.2rem; text-align: center">
          <b-button
            size="sm"
            class="col-md-5 col-12"
            variant="msstreamblue"
            style="padding:6px"
            v-b-modal.modal-new-team
          >
            <font-awesome-layers>
              <font-awesome-icon icon="user-friends" />
              <font-awesome-icon icon="plus" transform="shrink-7 right-15 up-1" />              
            </font-awesome-layers>&nbsp;&nbsp;&nbsp;
            {{$ml.get('createnewt')}}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-card-body>
</b-card>


    <b-modal
      id="modal-new-team"
      ref="modal-new-team"
      title="New team creation"
      @ok="createTeam"
      @show="loadModal"
      @hidden="resetModal"
      hide-footer
    >
      <b-form @submit.prevent="createTeam">
        <b-card border-variant="msstream" no-body>
          <b-card-header
            header-bg-variant="msstream"
            header-text-variant="white"
            class="text-center"
          >
            <h6 style="margin:0px">
              {{$ml.get('teaminfos')}}Team Infos
            </h6>
          </b-card-header>
          <b-table-simple stacked>
            <b-tbody>
              <b-tr>
                <b-td stacked-heading="Team name">

        <b-form-group
          class="small"
          id="input-group-1"
          :state="teamNameState"
          :invalid-feedback="teamNameFeedback"
          style="margin-top:-5px"
        >
          <b-form-input
            id="team-name"
            v-model="teamName"
            placeholder="Enter a team name"
            :state="teamNameState"
            required
          ></b-form-input>
        </b-form-group>
      </b-td>
      <b-td stacked-heading="Team Description">
        <b-form-group
          id="input-group-2"
          label-for="team-description"
          style="margin-top:-5px"
        >
          <b-form-textarea
            id="team-description"
            v-model="teamDescription"
            placeholder="Enter description for the team (optional)"
          ></b-form-textarea>
        </b-form-group>
      </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>

      <b-card border-variant="msstream" no-body style="margin-top: 20px">
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 style="margin:0px">
            {{$ml.get('teamembers')}}
          </h5>
        </b-card-header>


        <b-form-group
          style="margin-top: 10px"
          id="input-group-4"
          :state="collabNameState"
          :invalid-feedback="invalidFeedbackCollab"
        >
          <b-row style="margin:0px; padding: 3px 0px">
            <b-col cols="7">
              <b-form-input
                id="userInput"
                size="sm"
                placeholder="Search among collaborators"
                v-model="newCollabName"
                :state="collabNameState"
                required
                list="usersList"
                autocomplete="off"
              ></b-form-input>

              <b-form-datalist
                id="usersList"
                :options="usersList"
              ></b-form-datalist>
            </b-col>
            <b-col cols="5">
              <b-button size="sm" variant="msstreamblue" @click="addCollab()"
                >
                <b-icon icon="plus-circle" />
                {{$ml.get('addtotheteam')}}</b-button
              >
            </b-col>
          </b-row>
        </b-form-group>

        <b-table
          show-empty
          centered
          responsive
          striped
          bordered
          :items="collaborators"
          :fields="collabsTable"
        >
          <template v-slot:cell(collabName)="row">
            <div style="word-break:break-word; max-width:220px">{{ row.item.username }}</div>
          </template>

          <template v-slot:cell(collabRole)="row">
            <b-form-select v-model="row.item.role" :options="roles">
            </b-form-select>
          </template>

          <template v-slot:cell(collabActions)="row">
            <div style="text-align:center">
            <b-button size="sm" variant="quanteec" @click="removeUser(row.index)"
              ><font-awesome-icon icon="trash" />
            </b-button></div>
          </template>

        </b-table>
      </b-card>

      <b-row style="margin-top:15px">
        <div class="col-md-2"></div>
        <b-button class="col-md-3" type="submit" variant="msstreamblue">
          <font-awesome-icon icon="check" />
          {{$ml.get('create')}}
        </b-button>
        <div class="col-md-2"></div>
        <b-button class="col-md-3" @click="resetModal()" variant="mswarning">
          <font-awesome-icon icon="sync" />
          {{$ml.get('reset')}}
        </b-button>
      </b-row>

    </b-form>
    </b-modal>

    <b-modal
      id="modal-see-team"
      ref="modal-see-team"
      title=""
      @ok="resetModal"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-card border-variant="msstream" no-body>
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h4>{{$ml.get('teaminfos')}}</h4>
        </b-card-header>
        <b-table-simple stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Team name">{{
                teamSelected.teamName
              }}</b-td>
              <b-td stacked-heading="Team Description">{{
                teamSelected.teamDescription
              }}</b-td>
              <b-td stacked-heading="Owner">{{ teamSelected.ownerTeam }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

      <b-card border-variant="msstream" no-body style="margin-top: 20px">
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h4 v-text="$ml.get('members')"></h4>
        </b-card-header>
        <b-table
          show-empty
          centered
          responsive
          striped
          bordered
          :items="teamSelected.collabsTeam"
        >
        </b-table>
      </b-card>
    </b-modal>

    <b-modal
      id="modal-edit-team"
      ref="modal-edit-team"
      title="Team modification"
      @ok="editTeam"
      @show="loadModal"
      @hidden="resetModal"
      no-close-on-backdrop
      hide-footer
    >

      <b-card border-variant="msstream" no-body>
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 style="margin:0px" v-text="$ml.get('teaminfos')"></h5>
        </b-card-header>
        <b-table-simple stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Team name">
                <b-form-group
                  id="input-group-1"
                  :state="teamNameState"
                  invalid-feedback="A project name is required"
                  style="margin-top:-5px"
                >
                  <b-form-input
                    id="team-name"
                    v-model="teamSelected.teamName"
                    placeholder="Enter a team name"
                    :state="teamNameState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-td>
              <b-td stacked-heading="Team Description">
                <b-form-group id="input-group-2" style="margin-top:-5px">
                  <b-form-textarea
                    id="team-description"
                    v-model="teamSelected.teamDescription"
                    placeholder="Enter description for the team (optional)"
                  ></b-form-textarea>
                </b-form-group>
              </b-td>
              <b-td stacked-heading="Team Manager">{{ teamSelected.ownerTeam }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

      <b-card border-variant="msstream" no-body style="margin-top: 20px">
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 style="margin:0px">
            {{$ml.get('teamembers')}}
            <b-badge title="Number of members in the team" v-if="teamSelected.collabsTeam !== undefined">
              {{teamSelected.collabsTeam.length}}
            </b-badge>
          </h5>
        </b-card-header>
        <b-form-group
          style="margin-top: 10px"
          id="input-group-4"
          label-for="input-4"
          :state="collabNameState"
          :invalid-feedback="invalidFeedbackCollab"
        >
          <b-row style="margin:0px; padding: 3px 0px">
            <b-col cols="7" >
              <b-form-input
                size="sm"
                id="input-4"
                placeholder="Search among collaborators"
                v-model="newCollabName"
                :state="collabNameState"
                required
                list="usersList"
                autocomplete="off"
              ></b-form-input>
              <b-form-datalist
                id="usersList"
                :options="usersList"
              ></b-form-datalist>
            </b-col>
            <b-col cols="5">
              <b-button size="sm" variant="msstreamblue" @click="addCollabEdit()">
                <b-icon icon="plus-circle" />
                {{$ml.get('addtotheteam')}}
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
        <b-table
          show-empty
          centered
          responsive
          striped
          bordered
          :items="teamSelected.collabsTeam"
          :fields="collabsTable"
        >
          <template v-slot:cell(collabName)="row">
            <div style="word-break:break-word; max-width:220px">{{ row.item.username }}</div>
          </template>

          <template v-slot:cell(collabRole)="row">
            <b-form-select v-model="row.item.role" :options="roles">
            </b-form-select>
          </template>

          <template v-slot:cell(collabActions)="row">
            <div style="text-align:center">
            <b-button size="sm" variant="quanteec" @click="removeUser(row.index)"
              ><font-awesome-icon icon="trash" />
            </b-button></div>
          </template>
        </b-table>
      </b-card>

      <b-row style="margin-top:15px">
        <div class="col-md-2"></div>
        <b-button class="col-md-3" @click="editTeam(); hideModal('modal-edit-team')" variant="mswarning">
          <font-awesome-icon icon="check" />
          {{$ml.get('modify')}}
        </b-button>
        <div class="col-md-2"></div>
        <b-button class="col-md-3" @click="resetModal(); hideModal('modal-edit-team')" variant="quanteeclg">
          <font-awesome-icon style="color:red" icon="times" />
          {{$ml.get('cancel')}}
        </b-button>
      </b-row>

    </b-modal>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('teamdel')}}
        </h4>
      </div>
      <p style="line-height:normal" v-html="$ml.get('teamdeltxt')"></p>
      <p style="line-height:normal"> <strong><span style="color: #2F90B0; word-break:break-word">{{teamSelected.teamName}}</span></strong></p>
      <p style="line-height:normal" v-html="$ml.get('teamdeltxt2')"></p>

      <b-row class="justify-content-around">
        <b-btn class="col-5" variant="quanteec" @click="deleteTeam(teamSelected);hideModal('confirmDelete')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-5" variant="quanteeclg" @click="hideModal('confirmDelete')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="user-already-team" hide-footer hide-header>
      <div class="d-block text-center">
        <h3 v-text="$ml.get('error')"></h3>
      </div>
      <p>
        {{newCollabName}} {{$ml.get('alreadym')}}
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-5"
          variant="mswarning"
          block
          @click="hideModal('user-already-team')"
          > {{$ml.get('close')}} </b-btn
        >
      </b-row>
    </b-modal>

  </div>
</template>

<script>
let moment = require("moment");
import { EventBus } from "@/event-bus.js";
import ProjectService from "@/services/project.service.js";
import UserService from "@/services/user.service.js";
import TeamService from "@/services/team.service.js";
import { BASE_READER, EMBED_URL, WS_VIREED } from "@/services/base-url";
import io from "socket.io-client";

let projectService = new ProjectService();
var uService = new UserService();
let tService = new TeamService();
let ws_vireed = WS_VIREED;

export default {
  data() {
    return {
      teamsTable: [
        { key: "teamname", label: "Team name", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "descriptionTeam", label: "Description", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "owner", label: "Team Manager", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "members", label: "Members (+roles)", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "actions", label: "", thClass: 'text-center', tdClass: 'align-middle' },
      ],
      collabsTable: [
        { key: "collabName", label: "Collaborator", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "collabRole", label: "Role", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "collabActions", label: "Actions", thClass: 'text-center', tdClass: 'align-middle' },
      ],
      roles: ["admin", "editor", "viewer"],
      baseurl: BASE_READER,
      newCollabName: "",
      collabNameState: null,
      teamName: "",
      teamNameState: null,
      teamDescription: "",
      invalidFeedbackCollab: "Collaborator's username is required",
      collaborators: [],
      teamSelected: "",
      usersList: [],
      teams: [],
      teamNameFeedback: "A project name is required",
      teamsSelectecEditTpm:"",
    };
  },
  props: ["projectVersion", "userRole"],
  methods: {
    getTeams() {
      tService.getTeams(this.$auth.token()).then((teams) => {
        this.teams = teams;
      });
    },

    resetModal() {
      this.newCollabName = "";
      this.collabNameState = null;
      this.teamName = "";
      this.teamNameState = null;
      this.teamDescription = "";
      this.collaborators = [];
    },

    loadModal() {
      this.usersList = [];
      this.newCollabName = "";
      this.collabNameState = null;
      this.teamName = "";
      this.teamNameState = null;
      this.teamDescription = "";
      this.collaborators = [];

      uService.getUsers(this.$auth.token()).then((users) => {
        users.forEach((user) => {
          this.usersList.push(user.username);
        });
      });
    },

    addCollab() {
      if (!this.newCollabName) {
        this.invalidFeedbackCollab = "Collaborator's username is required";
        this.collabNameState = false;
        return;
      }

      if(this.collaborators.findIndex(collab=>collab.username === this.newCollabName) !=-1)
      {
        this.showModal('user-already-team')
        return;
      }

      uService
        .getUser(this.$auth.token(), this.newCollabName)
        .then((response) => {
          this.collabNameState = true;
          let newCollab = {
            username: this.newCollabName,
            role: "viewer",
          };
          this.collaborators.push(newCollab);
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.invalidFeedbackCollab =
              "User " + this.newCollabName + " not found";
            this.collabNameState = false;
          }
        });
    },

    addCollabEdit() {
      if (!this.newCollabName) {
        this.invalidFeedbackCollab = "Collaborator's username is required";
        this.collabNameState = false;
        return;
      }

      if(this.teamSelected.collabsTeam.findIndex(collab=>collab.username === this.newCollabName) !=-1)
      {
        this.showModal('user-already-team')
        return;
      }

      uService
        .getUser(this.$auth.token(), this.newCollabName)
        .then((response) => {
          this.collabNameState = true;
          let newCollab = {
            username: this.newCollabName,
            role: "viewer",
          };
          this.teamSelected.collabsTeam.push(newCollab);
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.invalidFeedbackCollab =
              "User " + this.newCollabName + " not found";
            this.collabNameState = false;
          }
        });
    },

    createTeam(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.teamName) {
        this.teamNameState = false;
        this.teamNameFeedback = "A project name is required";
        return;
      }

      let body = JSON.stringify({
        name: this.teamName,
        description: this.teamDescription,
        group: this.collaborators,
      });

      tService
        .createTeam(this.$auth.token(), body)
        .then((response) => {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-new-team");
            this.getTeams();
          });
        })
        .catch((err) => {
          this.teamNameState = false;
          this.teamNameFeedback = err.response.data;
        });
    },

    deleteTeam() {
      //On récupère les projets contenant l'équipe que l'on veut supprimer
      projectService
        .getProjectsFromTeam(this.$auth.token(), this.teamSelected.uuid)
        .then((responseProjects) => {
          //On supprime bien l'équipe en question
          tService
            .deleteTeam(this.$auth.token(), this.teamSelected.uuid)
            .then((response) => {
              this.getTeams();
              //To-Do : Envoyer l'info comme quoi la team a été "retiré du projet"
              responseProjects.forEach((project) => {
                let socket = io(ws_vireed, {});

                socket.on("connect", () => {
                  //On se positionne dans la room correspondant au projet
                  socket.emit("roomManage", project.uuid);
                });

                socket.on("connectedToRoom", () => {
                  socket.emit("teamRemove");
                  socket.disconnect();
                });
              });
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },

    editTeam() {
      let team = {
        teamName: this.teamSelected.teamName,
        teamDescription: this.teamSelected.teamDescription,
        collabsTeam: this.teamSelected.collabsTeam,
      };

      team = JSON.stringify(team);

      //On récupère les projets avec l'équipe modifiée
      projectService
        .getProjectsFromTeam(this.$auth.token(), this.teamSelected.uuid)
        .then((responseProjects) => {
          tService
            .updateTeam(this.$auth.token(), this.teamSelected.uuid, team)
            .then((response) => {
              responseProjects.forEach((project) => {
                let socket = io(ws_vireed, {});

                socket.on("connect", () => {
                  //On se positionne dans la room correspondant au projet
                  socket.emit("roomManage", project.uuid);
                });

                socket.on("connectedToRoom", () => {
                  socket.emit("teamEdit");
                  socket.disconnect();
                });
              });
              this.getTeams();
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },

    showModal(modal) {
      this.$refs[modal].show();
    },

    hideModal(modal) {
      this.$refs[modal].hide();
    },

    removeUser(idx) {
      this.teamSelected.collabsTeam.splice(idx, 1);
    },
    openChatTeam() {
      var url = "#/chat/team/" + this.teamSelected.uuid;
      window.open(url, this.teamSelected.name, "width=1200, height=750");
    },
  },
  mounted() {
    this.getTeams();
  },
};
</script>